<template>
    <div class="pt110" id="pt110" v-cloak>
        <!--パンくずリスト-->
        <breadcrumb :navList="pt110Init.navList" :routerNmItem="site+SiteConstants.PG010MAIN" :routerNmItemPageNo="'2'"></breadcrumb>
        <div>
            <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="'pt110'"/>
        </div>
        <!--カテゴリ名表示-->
        <template  v-if="pt110Init.navList != null && pt110Init.navList.length > 0">
            <!--親カテゴリ名-->
            <h2 v-if="pt110Init.categoryNmOptionFlg == 0">{{pt110Init.navList[0].CATEGORY_NM}}</h2>
            <!--子カテゴリ名-->
            <h2 v-else>{{pt110Init.navList.slice(-1)[0].CATEGORY_NM}}</h2>
        </template>
        <!--カテゴリ説明文(非表示) ※id='descriptionTagCategory'に設定された内容をdescriptionに入れる対応用-->
        <template  v-if="pt110Init.navList != null && pt110Init.navList.length > 0">
            <!--親カテゴリ名-->
            <p v-if="pt110Init.categoryNmOptionFlg == 0" v-html="pt110Init.navList[0].HDR_DISP" style="display:none"></p>
            <!--子カテゴリ名-->
            <p v-else v-html="pt110Init.navList.slice(-1)[0].HDR_DISP" style="display:none"></p>
        </template>
        <template v-if="showFlg">
            <page-feed
                :isDisplay="isPagingDisplay"
                :isDisplaySort="pt110Init.isDisplaySortFlg"
                :pageFeedData="pageFeedData"
                :orderByType="selectedSortNo"
                :dispPageSizeList="dispPageSizeList"
                :dispSortList="pt110Init.productSortKbnList"
                @search="changeSearch"
                >
                <!--通常:横レイアウト -->
                <template slot="TableRender" v-if="pt110Init.designFlg == 0">
                    <div class="sectionInner" v-if="pt110Init.productList == null || pt110Init.productList.length == 0">
                        <span  class="text-danger">
                            <!--検索条件に一致する商品がありませんでした。-->
                            {{$t('common.labels.messgNoResult')}}
                        </span>
                    </div>
                    <ul class="itemList">
                        <li v-for="(product, index) in pt110Init.productList" :key="index">
                            <div v-if="product.S_ITEM_CD != null" class="gridLink" @click="goDetail(product.S_ITEM_CD)">
                                <!--商品詳細遷移領域-->
                                <a class ="link" @click="doDetail(product.S_ITEM_CD)">
                                    <!--商品画像-->
                                    <img class="productImage" :src="product.IMG_URL1" alt="product.THUMBNAIL_DETAIL" @error="getErrImage">
                                </a>
                                <!-- 販売停止/代替商品 で、カート追加テキストがある場合 -->
                                <div class="itemAvailable" v-if="doChkCartAddTxt(product) && product.CART_ADD_TEXT">
                                    <div class="notSalesKbnText text-danger">
                                        {{product.CART_ADD_TEXT}}
                                    </div>
                                </div>
                                <!--販売期間内の場合でカートボタン表示オプション-->
                                <template v-else-if="product.HANBAI_FLG == 1 && cartShowFlg && !(pt110Init.siteKbn == '4' && !pt110Init.loginKbn)">
                                    <!--在庫がある場合に表示-->
                                    <div class="itemQty" v-if="!doChkCartAddTxt(product)">
                                        <!-- 数量： -->
                                        <span v-if="pt110Init.puldownFlg != 3">
                                            {{$t('pt110.labels.quantity')}}:
                                            <input-check v-if="product.ZAIKO_QTY > 0" v-model="product.QTY" :value="1" type="text" maxlength="5" size="3"
                                                class="productQty num" />
                                            <input-check v-else v-model="product.QTY" disabled :value="1" type="text" maxlength="5" size="3"
                                                class="productQtyDisabled num" />
                                        </span>
                                        <span v-else>
                                            <!--表示しない（数量1固定）-->
                                            <input-check type="text" class="productQtyDisabled num" maxlength="5" size="3" v-model="product.QTY" :value="1" disabled hidden/>
                                        </span>
                                    </div>
                                    <div class="itemAvailable">
                                        <button v-if="product.ZAIKO_QTY <= 0 || doChkCartAddTxt(product) || product.NO_LIMIT_FLG == '1'" disabled class="cart_order_disabled" >
                                            <!-- カートに入れる 在庫なし-->
                                            {{$t('pt110.buttons.outStock')}}
                                        </button>
                                        <button v-else class="btnSuccess" @click="pt110doOrder(product)">
                                            <!-- カートに入れる 在庫あり-->
                                            {{$t('pt110.buttons.addToCart')}}
                                        </button>
                                    </div>
                                </template>
                                <!-- まとめ買い割引情報 -->
                                <div class="itemMatome" v-if="!common.isNullItem(product.MATOME_TITLE_DETAIL) && ((product.NEED_MEMBER_FLG == 0) || (product.NEED_MEMBER_FLG == 1 && pt110Init.loginKbn == true))">
                                    <button class="btnSuccess" @click="showMatomeDetail(product)">
                                        <!-- まとめ買い割引情報-->
                                        <span id="toMatome" v-html="product.MATOME_TITLE_DETAIL"></span>
                                    </button>
                                </div>

                                <!-- 関連注文商品ボタン -->
                                <template v-for="(item, index) in product.LST_KANREN_ORD_INFO">
                                    <div :class="'kanrenOrderProduct kanrenOrderProduct_'+index" :key="index"
                                        v-if="!common.isNullItem(item.BUTTON_NM) && !common.isNullItem(item.KANREN_ORDER_ITEM_CD) && (item.BUTTON_PAGE == 0 || item.BUTTON_PAGE == 2)">
                                        <button :class="(pt110Init.siteKbn == '4' && !pt110Init.loginKbn) == false ? '' : 'disabled' + ' kanrenOrderBtn kanrenOrderBtn_'+index" @click="pt110doKanrenOrder(item.KANREN_ORDER_ITEM_CD,item.BUTTON_KBN)"
                                                :disabled="(pt110Init.siteKbn == '4' && !pt110Init.loginKbn) == false ? false : true">
                                            <span :id="'kanrenOrder_'+index" v-html="item.BUTTON_NM"></span>
                                        </button>
                                    </div>
                                </template>

                                <!--ログイン済みでtoCサイトでお気に未登録の場合表示-->
                                <template v-if="pt110Init.loginKbn == true">
                                    <!--お気に入りボタン表示オプション-->
                                    <div class="favourite" v-if="favourireShowFlg">
                                        <button v-if="favouriteAddFlg[index] == true" class="btn btn-favourite" @click="pt110favorites(1,product.S_ITEM_CD,product.WEB_ITEM_NM,index);"></button>
                                        <button v-else class=" btn btn-delete" @click="pt110favorites(2,product.S_ITEM_CD,product.WEB_ITEM_NM,index);"></button>
                                    </div>
                                </template>
                                <a class ="link" @click="doDetail(product.S_ITEM_CD)">
                                    <!--商品名＋キャッチコピー -->
                                    <span class="itemListDetail" >
                                        <strong class="webNm">
                                            <span v-html="product.CATCH_COPY_PRE"></span>
                                        </strong>
                                        <strong class="webNm">
                                            {{product.WEB_ITEM_NM}}
                                        </strong>
                                        <strong class="webNm">
                                            <span v-html="product.CATCH_COPY_SUF"></span>
                                        </strong>
                                    </span>
                                    <div class="proDetails">
                                        <span :href="'./' + 'PG010MainPage?pageNo=3&sItemNo=' + product.S_ITEM_CD">{{$t('pt110.labels.toDetail')}}</span>
                                    </div>
                                    <!-- 発売日 -->
                                    <div class="releaseDate" v-if="product.YOYAKU_ITEM_FLG == 1">
                                        {{$t('pt110.labels.releaseDate')}}: {{stringNvl(product.SELL_YMD,'')}}
                                    </div>
                                    <div class="priceContainer" v-if="!(pt110Init.siteKbn == '4' && !pt110Init.loginKbn) && pt110Init.priceShow != 1">
                                        <!--通常商品-->
                                        <template v-if="product.POINT_ITEM_KBN == '0' || product.POINT_ITEM_KBN == '2'">
                                            <!--税込金額 -->
                                            <span v-if="product.ZEI_SET_KBN == '1'">
                                                <span class='generalPriceTitle'>{{$t('common.labels.price')}}：</span>
                                                <span class="generalPrice">
                                                    {{formatPrice(product.SALE_ZEI_K_TNK)}}{{$t('common.labels.jpYen')}}&nbsp;
                                                </span>
                                            </span>
                                            <!--税抜金額 -->
                                            <span v-else>
                                                <span class='generalPriceTitle'>{{$t('common.labels.price')}}：</span>
                                                <span class="generalPrice">
                                                    {{formatPrice(product.SALE_TNK)}}{{$t('common.labels.jpYen')}}&nbsp;
                                                </span>
                                                <span class="priceTax">{{$t('common.labels.excludingtax')}}</span><br>
                                                <!--参考価格（税込）-->
                                                <span class='generalZeiPriceTitle'>{{$t('common.labels.zeiPrice')}}：</span>
                                                <span class="generalZeiPrice">
                                                    {{formatPrice(product.SALE_ZEI_K_TNK)}}{{$t('common.labels.jpYen')}}&nbsp;
                                                </span>
                                                <span class="zeiPriceTax">{{$t('common.labels.taxincluded')}}</span>
                                            </span>
                                            <template v-if="product.ITEM_ZEI_SET_KBN != '0'">
                                                <!-- (税込) -->
                                                <span class="priceTax" v-if="product.ZEI_SET_KBN == '1'">{{$t('common.labels.taxincluded')}}</span>
                                            </template>
                                            <!-- 消費税率 -->
                                            <template v-if="pt110Init.dispTaxRtFlg == 1">
                                                <dl class="taxRateInfo">
                                                    <template v-if="product.ITEM_ZEI_SET_KBN == '0'">
                                                        <dt>
                                                            <span class="taxInfoTitle">{{$t('common.labels.taxRate0')}}</span>
                                                        </dt>
                                                    </template>
                                                    <template v-else>
                                                        <dt>
                                                            <span class="taxInfoTitle">{{$t('common.labels.taxRate')}}</span>
                                                        </dt>
                                                        <dd>
                                                            <span class="taxInfoValue">
                                                                <span class="taxInfoRt">{{product.ITEM_ZEI_SET_KBN}}</span>
                                                                <span class="taxInfoPer">{{$t('common.labels.percentUnit')}}</span>
                                                            </span>
                                                        </dd>
                                                    </template>
                                                </dl>
                                            </template>
                                            <!--値引価格 -->
                                            <template v-if="(product.NEBIKI_PRICE > 0 && product.NEBIKI_PRICE != product.PRICE)">
                                                <!--値引価格 -->
                                                <template>
                                                    <br>
                                                    <span class='nebikiPriceTitle'>{{$t('common.labels.nebikiPrice')}}：</span>
                                                    <span class="nebikiPrice">
                                                        {{formatPrice(product.NEBIKI_PRICE)}}{{$t('common.labels.jpYen')}}&nbsp;
                                                    </span>
                                                </template>
                                                <template v-if="product.ITEM_ZEI_SET_KBN != '0'">
                                                    <!-- (税込) -->
                                                    <span class="priceTax" v-if="product.ZEI_SET_KBN == '1'">{{$t('common.labels.taxincluded')}}</span>
                                                    <!-- (税抜) -->
                                                    <span class="priceTax" v-else>{{$t('common.labels.excludingtax')}}</span>
                                                </template>
                                                <span v-if="pt110Init.itemKgkNebikiFlg == 1" class="nebikiRate">
                                                    <br>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    {{product.NEBIKI_RATE}}%{{$t('common.labels.nebikiRtRate')}}
                                                </span>
                                            </template>
                                            <template v-if="(product.POINT_NUM > 0)">
                                                <br>
                                                <span class="pointNum">
                                                    {{formatPrice(product.POINT_NUM)}}{{$t('common.labels.pointGrantNum')}}
                                                </span>
                                            </template>
                                            <!--ポイントキャンペーン対象商品 -->
                                            <template v-if="(product.PROMO_POINT_NUM > 0)">
                                                <br>
                                                <span class="pointGrantCampaign" v-if="(product.POINT_NUM > 0)">
                                                    {{$t('common.labels.pointGrantCampaign')}}
                                                </span>
                                                <span class="pointCampaign">
                                                    {{formatPrice(product.PROMO_POINT_NUM)}}{{$t('common.labels.pointGrantNum')}}
                                                </span>
                                            </template>
                                            <!--ポイント付与 -->
                                            <br/>
                                        </template>
                                        <!--ポイント交換商品-->
                                        <template v-if="product.POINT_ITEM_KBN == '1' || product.POINT_ITEM_KBN == '2'">
                                            <span class="price">
                                                {{formatPrice(product.POINT_ITEM_NUM)}}{{$t('common.labels.pt')}}
                                            </span>
                                        </template>
                                    </div>
                                    <!-- 温度帯 -->
                                    <div class="ondotaiInfo" v-if="pt110Init.dispOndotaiFlg == 1">
                                        <span :class="'ondotaiTitle ondotaiKbn_'+product.ONDO_KBN">{{$t('pt110.labels.temperatureZone')}}：</span>
                                        <span :class="'ondotaiValue ondotaiKbn_'+product.ONDO_KBN">{{product.ONDO_NM}}</span>
                                    </div>
                                    <!--限定数量残無しメッセージ、当日残無しメッセージの表示-->
                                    <div class="limitMsgShow" v-if="product.NO_LIMIT_FLG == '1'">
                                        <span class="text-danger">
                                            {{product.NO_LIMIT_MSG}}
                                        </span>
                                    </div>
                                    <template v-if="product.HANBAI_FLG == 1">
                                        <template v-if="(product.ZAIKO_DISP_PLACE_KBN== '0' || product.ZAIKO_DISP_PLACE_KBN == '1') && product.ZAIKO_DISP_WAY_KBN !='0'">
                                            <div class="zaikoInfo">
                                                <!--在庫数表示、両方表示の場合 -->
                                                <template v-if="product.ZAIKO_DISP_WAY_KBN == '2' || product.ZAIKO_DISP_WAY_KBN == '3'">
                                                    <!-- 在庫数 -->
                                                    <span class="zaikoQty">{{$t('pt120.labels.numberOfStock')}}：{{formatPrice(product.ZAIKO_QTY)}}</span>
                                                </template>
                                                <!-- 在庫状態表示、両方表示の場合 -->
                                                <template v-if="product.ZAIKO_DISP_WAY_KBN == '1' || product.ZAIKO_DISP_WAY_KBN == '3'">
                                                    <template v-if="product.ZAIKO_DISP_WAY_KBN == '3'"><br></template>
                                                    <!-- 在庫なし-->
                                                    <template v-if="product.ZAIKO_QTY <= 0 || doChkCartAddTxt(product)">
                                                        <span class="zaikoMsg" v-if="product.ZAIKO_MSG3 == null">{{$t('pt110.labels.stock')}}：{{$t('pt110.labels.none')}}</span>
                                                        <span class="zaikoMsg" v-else>{{$t('pt110.labels.stock')}}：&nbsp;{{product.ZAIKO_MSG3}}</span>
                                                    </template>
                                                    <!-- 残りわずか -->
                                                    <template v-else-if="product.ZAIKO_QTY > 0 && product.ZAIKO_QTY <= product.ZAIKO_CNT">
                                                        <span class="zaikoMsg" v-if="product.ZAIKO_MSG2 == null">{{$t('pt110.labels.stock')}}：{{$t('pt110.labels.onlyFewRemaining')}}</span>
                                                        <span class="zaikoMsg" v-else>{{$t('pt110.labels.stock')}}：&nbsp;{{product.ZAIKO_MSG2}}</span>
                                                    </template>
                                                    <template v-else-if="product.ZAIKO_QTY > product.ZAIKO_CNT">
                                                        <!-- あり -->
                                                        <span class="zaikoMsg" v-if="product.ZAIKO_MSG1 == null">{{$t('pt110.labels.stock')}}：{{$t('pt110.labels.there')}}</span>
                                                        <span class="zaikoMsg" v-else>{{$t('pt110.labels.stock')}}：&nbsp;{{product.ZAIKO_MSG1}}</span>
                                                    </template>
                                                </template>
                                            </div>
                                        </template>
                                    </template>
                                    <!-- 自動発注不可アイコン -->
                                    <div class="autoHatchuNgIcon mr-2" v-if="pt110Init.autoHachuFlg == 1 && product.AUTO_HACHU_FLG == 0">&emsp;</div>
                                    <!-- 特約商品 -->
                                    <div class="toyakiContainer">
                                        <template v-for="i in 15">
                                            <span :class="'itemIcon'+ (i<10 ? '0':'') + i" v-if="product[`ITEM_STATUS${i}`]  == 0" :key="i">
                                                <font :class="'itemIconStar'+ (i<10 ? '0':'') + i" color="gold" style="font-size:11px;">{{$t('pt120.labels.star')}}</font>
                                                <font :class="'itemIconNm'+ (i<10 ? '0':'') + i" color="#ff0033" style="font-size:11px;">{{product[`ICON_NM${i}`]}}</font>
                                            </span>
                                        </template>
                                    </div>
                                    <br>
                                    <div v-for="(kbnMap, indx) in pt110Init.uketoriServiceKbnList" :key="indx" v-bind:class="'uketoriServiceInfo'+indx">
                                        <template v-if="kbnMap.UKETORI_SERVICE_KBN == '3' && product.CONVENI_UKE_FLG =='1'">
                                            <span class="yuubinNomal">
                                                <font color="gold" style="font-size:11px;">★</font>
                                                <font color="#ff0033" style="font-size:11px;">{{pt110Init.uketoriServiceKbn[0].MARK_NM}}可</font>
                                            </span>
                                        </template>
                                        <template v-if="kbnMap.UKETORI_SERVICE_KBN == '4' && product.YUUBINKYOKU_UKE_FLG =='1'">
                                            <span class="yuubinJp">
                                                <font color="gold" style="font-size:11px;">★</font><font color="#ff0033" style="font-size:11px;">
                                                    {{pt110Init.uketoriServiceKbn[1].MARK_NM}}可
                                                </font>
                                                <img width="25" height="25" src="../img/icons/jp_logo.gif" alt="郵便局窓口受取">
                                            </span>
                                        </template>
                                        <template v-if="kbnMap.UKETORI_SERVICE_KBN == '5' && product.HAKOPOST_UKE_FLG =='1'">
                                            <span class="yuubinHako">
                                                <font color="gold" style="font-size:11px;">★</font>
                                                <font color="#ff0033" style="font-size:11px;">{{pt110Init.uketoriServiceKbn[2].MARK_NM}}可</font>
                                                <img width="25" height="25" src="../img/icons/jp_hako_logo.gif" alt="はこぽす">
                                            </span>
                                        </template>
                                    </div>
                                </a><!--商品詳細遷移領域ここまで-->
                            </div>
                        </li>
                    </ul>
                </template>
                <!--オプション:縦レイアウト -->
                <template slot="TableRender" v-else>
                    <div class="section-inner mb16" v-if="pt110Init.productList == null || pt110Init.productList.length == 0">
                        <span  class="text-danger">
                            {{$t('common.labels.messgNoResult')}}
                        </span>
                    </div>
                    <div v-else-if="!(pt110Init.productList == null || pt110Init.productList.length == 0) && cartShowFlg && pt110Init.puldownFlg != 3">
                        <!--カートに追加ボタン-->
                        <input id="cart-add-button" @click="doOrderPt110(pt110Init.productList)" :value="$t('pt110.buttons.cartAddBtn')" type="button">
                    </div>
                    <table id="product-list">
                        <tr v-for="(product, index) in pt110Init.productList" :key="index">
                            <th id="itemListImg" :style="pt110Init.itemImgFlg == 0?'display:none;':''">
                                <img style="width:80px; height:80px;" :src="product.IMG_URL1" alt="product.THUMBNAIL_DETAIL" @error="getErrImage">
                            </th>
                            <td>{{product.S_ITEM_CD}}</td>
                            <td>
                                <ul>
                                    <li v-html="product.CATCH_COPY_PRE"></li>
                                    <li>{{product.WEB_ITEM_NM}}</li>
                                    <li v-html="product.CATCH_COPY_SUF"></li>
                                    <li>
                                        <template v-if="product.YOYAKU_ITEM_FLG == 1">
                                            {{$t('pt110.labels.releaseDate')}}: {{stringNvl(product.SELL_YMD,'')}}&nbsp;
                                        </template>
                                        <!-- 温度帯 -->
                                        <template v-if="pt110Init.dispOndotaiFlg == 1">
                                            <div class="ondotaiInfo">
                                                <span :class="'ondotaiTitle ondotaiKbn_'+product.ONDO_KBN">{{$t('pt110.labels.temperatureZone')}}：</span>
                                                <span :class="'ondotaiValue ondotaiKbn_'+product.ONDO_KBN">{{product.ONDO_NM}}</span>
                                                <br>
                                            </div>
                                        </template>
                                        <template v-if="product.HANBAI_FLG == 1">
                                            <template v-if="(product.ZAIKO_DISP_PLACE_KBN== '0' || product.ZAIKO_DISP_PLACE_KBN == '1') && product.ZAIKO_DISP_WAY_KBN !='0'">
                                                <!--在庫数表示、両方表示の場合 -->
                                                <template v-if="product.ZAIKO_DISP_WAY_KBN == '2' || product.ZAIKO_DISP_WAY_KBN == '3'">
                                                    {{$t('pt120.labels.numberOfStock')}}：{{formatPrice(product.ZAIKO_QTY)}}&nbsp;
                                                </template>
                                                <!-- 在庫状態表示、両方表示の場合 -->
                                                <template v-if="product.ZAIKO_DISP_WAY_KBN == '1' || product.ZAIKO_DISP_WAY_KBN == '3'">
                                                    <!-- 在庫なし-->
                                                    <template v-if="product.ZAIKO_QTY <= 0">
                                                        <template v-if="product.ZAIKO_MSG3 == null">{{$t('pt110.labels.stock')}}：{{$t('pt110.labels.none')}}</template>
                                                        <template v-else>{{$t('pt110.labels.stock')}}：&nbsp;{{product.ZAIKO_MSG3}}</template>
                                                    </template>
                                                    <!-- 残りわずか -->
                                                    <template v-else-if="product.ZAIKO_QTY > 0 && product.ZAIKO_QTY <= product.ZAIKO_CNT">
                                                        <template v-if="product.ZAIKO_MSG2 == null">{{$t('pt110.labels.stock')}}：{{$t('pt110.labels.onlyFewRemaining')}}</template>
                                                        <template v-else>{{$t('pt110.labels.stock')}}：&nbsp;{{product.ZAIKO_MSG2}}</template>
                                                    </template>
                                                    <!-- あり -->
                                                    <template v-else-if="product.ZAIKO_QTY > product.ZAIKO_CNT">
                                                        <template v-if="product.ZAIKO_MSG1 == null">{{$t('pt110.labels.stock')}}：{{$t('pt110.labels.there')}}</template>
                                                        <template v-else>{{$t('pt110.labels.stock')}}：&nbsp;{{product.ZAIKO_MSG1}}</template>
                                                    </template>
                                                </template>
                                            </template>
                                        </template>
                                    </li>
                                </ul>
                            </td>
                            <td v-if="!(pt110Init.siteKbn == '4' && !pt110Init.loginKbn) && pt110Init.priceShow != 1">
                                <template v-if="product.POINT_ITEM_KBN == '0' || product.POINT_ITEM_KBN == '2'">
                                    <!--税込金額 -->
                                    <span v-if="product.ZEI_SET_KBN == '1'">
                                        <span class='generalPriceTitle'>{{$t('common.labels.price')}}：</span>
                                        <span class="generalPrice">
                                        {{formatPrice(product.SALE_ZEI_K_TNK)}}{{$t('common.labels.jpYen')}}
                                        </span>
                                    </span>
                                    <!--税抜金額 -->
                                    <span v-else>
                                        <span class='generalPriceTitle'>{{ $t('common.labels.price')}}：</span>
                                        <span class="generalPrice">
                                        {{formatPrice(product.SALE_TNK)}}{{$t('common.labels.jpYen')}}
                                        </span>
                                        <span class="priceTax">{{$t('common.labels.excludingtax')}}</span><br>
                                        <!--参考価格（税込）-->
                                        <span class='generalZeiPriceTitle'>{{$t('common.labels.zeiPrice')}}：</span>
                                        <span class="generalZeiPrice">
                                            {{formatPrice(product.SALE_ZEI_K_TNK)}}{{$t('common.labels.jpYen')}}&nbsp;
                                        </span>
                                        <span class="zeiPriceTax">{{$t('common.labels.taxincluded')}}</span>
                                    </span>
                                    <template v-if="product.ITEM_ZEI_SET_KBN != '0'">
                                        <!-- (税込) -->
                                        <sapn class="priceTax" v-if="product.ZEI_SET_KBN == '1'">{{$t('common.labels.taxincluded')}}</sapn>
                                    </template>
                                    <!-- 消費税率 -->
                                    <template v-if="pt110Init.dispTaxRtFlg == 1">
                                        <dl class="taxRateInfo">
                                            <template v-if="product.ITEM_ZEI_SET_KBN == '0'">
                                                <dt>
                                                    <span class="taxInfoTitle">{{$t('common.labels.taxRate0')}}</span>
                                                </dt>
                                            </template>
                                            <template v-else>
                                                <dt>
                                                    <span class="taxInfoTitle">{{$t('common.labels.taxRate')}}</span>
                                                </dt>
                                                <dd>
                                                    <span class="taxInfoValue">
                                                        <span class="taxInfoRt">{{product.ITEM_ZEI_SET_KBN}}</span>
                                                        <span class="taxInfoPer">{{$t('common.labels.percentUnit')}}</span>
                                                    </span>
                                                </dd>
                                            </template>
                                        </dl>
                                    </template>
                                    <!--値引価格 -->
                                        <template v-if="(product.NEBIKI_PRICE > 0 && product.NEBIKI_PRICE != product.PRICE)">
                                            <!--値引価格 -->
                                            <template>
                                            <br>
                                            <span class='nebikiPriceTitle'>{{$t('common.labels.nebikiPrice')}}：</span>
                                            <span class="nebikiPrice">
                                                {{formatPrice(product.NEBIKI_PRICE)}}{{$t('common.labels.jpYen')}}&nbsp;
                                            </span>
                                        </template>
                                        <template v-if="product.ITEM_ZEI_SET_KBN != '0'">
                                            <!-- (税込) -->
                                            <span class="priceTax" v-if="product.ZEI_SET_KBN == '1'">{{$t('common.labels.taxincluded')}}</span>
                                            <!-- (税抜) -->
                                            <span class="priceTax" v-else>{{$t('common.labels.excludingtax')}}</span>
                                        </template>
                                        <span v-if="pt110Init.itemKgkNebikiFlg == 1" class="nebikiRate">
                                            <br>
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            {{product.NEBIKI_RATE}}%{{$t('common.labels.nebikiRtRate')}}
                                        </span>
                                    </template>
                                    <!--ポイント付与 -->
                                    <template v-if="(product.POINT_NUM > 0)">
                                        <br>
                                        <span class="pointNum">
                                            {{formatPrice(product.POINT_NUM)}}{{$t('common.labels.pointGrantNum')}}
                                        </span>
                                    </template>
                                    <!--ポイントキャンペーン対象商品 -->
                                    <template v-if="(product.PROMO_POINT_NUM > 0)">
                                        <br>
                                        <span class="pointGrantCampaign" v-if="(product.POINT_NUM > 0)">
                                            {{$t('common.labels.pointGrantCampaign')}}
                                        </span>
                                        <span class="pointCampaign">
                                            {{formatPrice(product.PROMO_POINT_NUM)}}{{$t('common.labels.pointGrantNum')}}
                                        </span>
                                    </template>
                                </template>
                                <!--ポイント交換商品-->
                                <template v-if="product.POINT_ITEM_KBN == '1' || product.POINT_ITEM_KBN == '2'">
                                    <span class="price">
                                        {{formatPrice(product.POINT_ITEM_NUM)}}{{$t('common.labels.pt')}}
                                    </span>
                                </template>
                            </td>
                            <td v-if="cartShowFlg && pt110Init.puldownFlg != 3">
                                <!-- 数量： -->
                                <div class="itemQty">
                                    <span>
                                        {{$t('pt110.labels.quantity')}}:
                                        <input-check v-if="product.ZAIKO_QTY > 0" v-model="product.QTY" :value="0" type="text" maxlength="5" size="5"
                                            class="productQty num" :id="'itemQty_' + index" @on-change="getAnimalQty(product.QTY, index, product.SYUKKA_NUM)"/>
                                        <input-check v-else v-model="product.QTY" disabled :value="0" type="text" maxlength="5" size="5"
                                            class="productQtyDisabled num" :id="'itemQty_' + index"/>
                                    </span>
                                </div>
                            </td>
                            <td v-if="cartShowFlg && pt110Init.auraOpt == 1 && pt110Init.puldownFlg != 3">
                                <!-- 匹数： -->
                                <div class="animalQty">
                                    <span>
                                        {{$t('pt110.labels.animalQty')}}:
                                        <input-check type="text" class="productQty num" :id="'animalQty_' + index" maxlength="7" size="7" v-model="product.ANIMAL_QTY" :value="0"
                                            @on-change="getItemQty(product.ANIMAL_QTY, index, product.SYUKKA_NUM)" :disabled="product.SYUKKA_NUM === 1 ? true : false"/>
                                    </span>
                                </div>
                            </td>
                            <td>
                                <input id="nav-search-button" @click="doDetail(product.S_ITEM_CD)" :value="$t('pt110.labels.toDetail')" type="button">
                            </td>
                            <td v-if="(pt110Init.autoHachuFlg == 1 && product.AUTO_HACHU_FLG == 0) || iconFlg || uketoriServiceFlg">
                                <!-- 自動発注不可アイコン -->
                                <div class="autoHatchuNgIcon mr-2" v-if="pt110Init.autoHachuFlg == 1 && product.AUTO_HACHU_FLG == 0">&emsp;</div>
                                <!-- 特約商品 -->
                                <div class="toyakiContainer">
                                    <div v-for="i in 15" :key="i">
                                        <span :class="'itemIcon'+ (i<10 ? '0':'') + i" v-if="product[`ITEM_STATUS${i}`]  == 0">
                                            <font :class="'itemIconStar'+ (i<10 ? '0':'') + i" color="gold" style="font-size:11px;">{{$t('pt120.labels.star')}}</font>
                                            <font :class="'itemIconNm'+ (i<10 ? '0':'') + i" color="#ff0033" style="font-size:11px;">{{product[`ICON_NM${i}`]}}</font>
                                        </span>
                                    </div>
                                </div>
                                <div v-for="(kbnMap, indx) in pt110Init.uketoriServiceKbnList" :key="indx" v-bind:class="'uketoriServiceInfo'+indx">
                                    <div v-if="kbnMap.UKETORI_SERVICE_KBN == '3' && product.CONVENI_UKE_FLG =='1'">
                                        <span class="yuubinNomal">
                                            <font color="gold" style="font-size:11px;">★</font>
                                            <font color="#ff0033" style="font-size:11px;">{{pt110Init.uketoriServiceKbn[0].MARK_NM}}可</font>
                                        </span>
                                    </div>
                                    <div v-if="kbnMap.UKETORI_SERVICE_KBN == '4' && product.YUUBINKYOKU_UKE_FLG =='1'">
                                        <span class="yuubinJp">
                                            <font color="gold" style="font-size:11px;">★</font><font color="#ff0033" style="font-size:11px;">
                                                {{pt110Init.uketoriServiceKbn[1].MARK_NM}}可
                                            </font>
                                            <img width="20" height="20" src="../img/icons/jp_logo.gif" alt="郵便局窓口受取">
                                        </span>
                                    </div>
                                    <div v-if="kbnMap.UKETORI_SERVICE_KBN == '5' && product.HAKOPOST_UKE_FLG =='1'">
                                        <span class="yuubinHako">
                                            <font color="gold" style="font-size:11px;">★</font>
                                            <font color="#ff0033" style="font-size:11px;">{{pt110Init.uketoriServiceKbn[2].MARK_NM}}可</font>
                                            <img width="20" height="20" src="../img/icons/jp_hako_logo.gif" alt="はこぽす">
                                        </span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>
                </template>
            </page-feed>
        </template>

        <span id="qty_lbl" style="display:none">
            {{$t('pt110.labels.quantity')}}
        </span>
        <!-- modal confirm area -->
        <alert-confirm
            v-if="isModalShow"
            :msgConfirm="msgConfirm"
            :isButtonCancel="false"
        >
        </alert-confirm>
        <COLOR_SIZE v-if="colorSizeFlg" :data="dataColorSize" @modal-close="colorSizeFlg = false" @set-addr-value="setValue"></COLOR_SIZE>

        <b-modal v-model="showPassModal"
            size="md"
            header-bg-variant="light"
            :title="$t('pt110.labels.accessDialogTitle')" 
            no-close-on-backdrop
            :cancel-title="$t('common.buttons.cancel')"
            :ok-title="$t('pt110.labels.access')"
            @ok="okAction">

            <div v-if="warningMsg" class="col-12 mb-1">
                <span class="text-danger">{{warningMsg}}</span>
            </div>

            <div class="col-8">
                <input-check
                    v-model="pt110ReqModel.secretPassword"
                    type="password" 
                    name="secretPassword"
                    class="form-control form-control w-100 multi" 
                    maxlength="20"
                />
            </div>

        </b-modal>
    </div>
</template>

<script>
/*
* Import libs and componnents
*/
import axios from "assets/js/request";
import DataTable from 'components/Datatable';
import common from 'assets/js/common';
import BackButton from 'components/BackButton';
import AlertConfirm from 'components/AlertConfirm';
import EventBus from 'assets/js/eventBus';
import Message from 'components/MessageEcSite';
import InputCheck from 'components/InputCheck.vue';
import DownloadFile from 'components/DownloadFile';
import PageFeed from "../commonParts/PageFeed";
import SiteConstants from 'assets/const/SiteConstants.json';
import InputNumber from 'components/InputNumber';
import Breadcrumb from "../commonParts/Breadcrumb.vue";
import toastr from "toastr/toastr.js";
import "toastr/build/toastr.min.css";
import COLOR_SIZE from '../parts/PT110_colorSizeModal.vue';
import Constants from 'assets/const/Constants.json';
import commonEc from "assets/js/common_ec";
import Vue from 'vue';
import VueMeta from 'vue-meta';

Vue.use(VueMeta);

toastr.options = {
  closeButton: true,
  positionClass: "toast-top-right",
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "2000",
};

export default {
    /*
    * Name of component
    */
    name: "PT110ProductListParts",
    /*
    * Declare components
    */
    components: {
        DataTable,
        BackButton,
        Message,
        InputCheck,
        DownloadFile,
        AlertConfirm,
        PageFeed,
        Breadcrumb,
        InputNumber,
        toastr,
        COLOR_SIZE
    },
    /*
    * Declare props
    */
    props: {
        ptPageNo: {
            type: [Number,String]
        },
        ptPageSize: {
            type: [Number,String]
        },
        ptOrderByType: {
            type: [Number,String]
        },
        categoryCd:  {
            type: String
        },
        evtChangeCategoryFlg: {
            type: Boolean,
            default: false,
        },
        evtChangeSearchFlg: {
            type: Boolean,
            default: false,
        },
        searchNm : {
            type: String
        },
        ptInitData: {
            type: Object,
            default: null,
        },
    },
    /*
    * Declare variable and set default value
    */
    data: function() {
        return {
            isDisplay: false,
            isDownload: false,
            isPagingDisplay:true,
            pt110Init: {
                productList: [],
                colorTitle:'',
                sizeTitle:'',
                categoryNmOptionFlg: 0,
                productSortKbnList: [],
                isDisplaySortFlg: false,
            },
            pt110ReqModel: {
                totalRecord: null,
                fromRecord: null,
                toRecord: null,
                pageSize: this.ptPageSize != undefined ? this.ptPageSize : 16,
                pageNo: this.ptPageNo != undefined ? this.ptPageNo : 1,
                pointFlg: 0
            },
            isModalShow:false,
            msgConfirm:'',
            common:common,
            queryData:null,
            paramsData:null,
            pageFeedData: {
                totalRecord: 50,
                fromRecord: 1,
                toRecord: 10,
                pageSize: 16,
                pageNo: 1
            },
            dispPageSizeList:[],
            SiteConstants: SiteConstants,
            Constants: Constants,
            listIdErr:[],
            listMessValid:[],
            mapMessValid:[],
            showFlg:false,
            site: "",
            cartShowFlg:false,
            favourireShowFlg:false,
            favouriteAddFlg:[],
            colorSizeFlg : false,
            colorSizeModal:{
                colSizList : [],
                csitemimg : "",
                colorTitle:'',
                sizeTitle:'',
            },
            dataColorSize:{},
            colorSizeQty : 0,
            colorSizeTnk : 0,
            colorSizeItemNm : "",
            selectedSortNo : this.ptOrderByType,
            showPassModal: false,
            warningMsg: '',
            commonEc:commonEc,
            uketoriServiceFlg: true,
            iconFlg: true,
            titleNm: '',
            categoryDescription: '',
        }
    },
    //meta description
    metaInfo() {
        return {
            title: this.titleNm,
            meta: [
                {name: 'title', content: this.titleNm},
                {name: 'description', content: this.categoryDescription},
                {name: 'og:title', content: this.titleNm},
                {name: 'og:description', content: this.categoryDescription}
            ]
        };
    },
    /*
    * Initialize
    */
    mounted: function() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];

        if (_this.ptInitData){
            _this.pt110Init = _this.ptInitData;
           
            _this.$nextTick(() => {
                let robots = document.querySelector('meta[name="robots"]');
                if(_this.pt110Init.accessDialogFlg == 1) {
                    //シークレットでパスワード入力させるカテゴリの時、検索対象外<meta name="robots" content="noindex,nofollow" />とする
                    if (robots){
                        robots.setAttribute("content","noindex,nofollow");
                    }else{
                        robots = document.createElement("meta");
                        robots.setAttribute("name","robots");
                        robots.setAttribute("content","noindex,nofollow");
                        document.head.appendChild(robots);
                    }

                }else{
                    if (robots){
                        document.head.removeChild(robots);
                    }
                    //<title>タグで「カテゴリ名 | サイト名」とする※既存ではサイト名のみ
                    if (_this.pt110Init.categoryNm){
                        document.title = _this.pt110Init.categoryNm + " | " + _this.pt110Init.siteNm;
                    }else{
                        document.title =_this.pt110Init.siteNm;
                    }
                    this.titleNm = _this.pt110Init.categoryNm + ' | ' +_this.pt110Init.siteNm;
                    //<meta property="og:title">タグでcontentをカテゴリ名とする
                    let ogTitle = document.querySelector('meta[property="og:title"]');
                    if (ogTitle){
                        if (_this.pt110Init.categoryNm){
                            ogTitle.setAttribute("content", _this.pt110Init.categoryNm);
                        }
                    }
                    //<meta property="og:site_name">タグでcontentをサイト名とする
                    let ogSiteName = document.querySelector('meta[property="og:site_name"]');
                    if (ogSiteName) {
                        ogSiteName.setAttribute("content", _this.pt110Init.siteNm);
                    }
                    //<meta keywords>に「カテゴリ名,」を先頭に追加する
                    let keywords = document.querySelector('meta[name="keywords"]');
                    if (keywords) {
                        let keywordsText = keywords.getAttribute("content");
                        if (_this.pt110Init.categoryNm){
                            if (keywordsText){
                                keywords.setAttribute("content", _this.pt110Init.categoryNm + "," + keywordsText);
                            }else{
                                keywords.setAttribute("content", _this.pt110Init.categoryNm);
                            }
                        }else{
                            keywords.setAttribute("content", keywordsText);
                        }
                    }

                    var categoryDescriptionElement = document.getElementById('descriptionTagCategory');
                    var categoryDescriptionText = categoryDescriptionElement.textContent;

                    this.categoryDescription = categoryDescriptionText;  
                }  
            });

            if(_this.pt110Init.accessDialogFlg == 1 && !_this.pt110ReqModel.secretPassword) {
                _this.showPassModal = true;
                return;
            } else if (_this.pt110Init.accessDialogFlg == 0) {
                _this.setCookie('secret', '', 0);
            } else {
                this.doInit();
            }

            // カートに入れるボタン表示オプション 0:表示しない 1:表示する
            if (_this.pt110Init.cartButtonFlg == 1) {
                _this.cartShowFlg = true;
            }
            // お気に入りボタン表示オプション 0:表示しない 1:表示する
            if (_this.pt110Init.favouriteButtonFlg == 1) {
                _this.favourireShowFlg = true;
            }
            if(_this.ptInitData.productList != null){

                _this.pageFeedData.totalRecord = _this.ptInitData.totalRecord;
                _this.pageFeedData.fromRecord = _this.ptInitData.fromRecord;
                _this.pageFeedData.toRecord = _this.ptInitData.toRecord;
                _this.pageFeedData.pageSize = _this.ptInitData.pageSize;
                _this.pageFeedData.pageNo = _this.ptInitData.pageNo;
                if(_this.ptInitData.productList.length > 0){
                    _this.isPagingDisplay = true;
                }else{
                    _this.isPagingDisplay = false;
                }
                // お気に入りボタンの初期値設定
                for (var i = 0; i < _this.pt110Init.productList.length; i++) {
                    if (_this.pt110Init.productList[i].OKINI_ITEM_CD == "0") {
                        _this.favouriteAddFlg[i] = true;
                    } else {
                        _this.favouriteAddFlg[i] = false;
                    }
                }
            }
            if (_this.pt110Init.productSortKbnList != null && _this.pt110Init.productSortKbnList.length > 0) {
                // 表示順のデフォルト値
                _this.selectedSortNo = _this.ptInitData.reqModel.selectedSortNo;
                _this.pt110Init.isDisplaySortFlg = true;
            } else {
                _this.selectedSortNo = 0;
                _this.pt110Init.isDisplaySortFlg = false;
            }
            _this.dispPageSizeList = _this.pt110Init.pageSizeList;

            if (_this.pt110Init.uketoriServiceKbnList.length >= 0) {
                _this.uketoriServiceFlg = false;
            }

            var iconFlgCount = 0;
            for (var i = 0; i < _this.pt110Init.productList.length; i++) {
                if (_this.pt110Init.productList[i].ITEM_STATUS1 == "0" || _this.pt110Init.productList[i].ITEM_STATUS2 == "0" || _this.pt110Init.productList[i].ITEM_STATUS3 == "0") {
                    iconFlgCount++;
                }
            }
            iconFlgCount == 0 ? _this.iconFlg = false : _this.iconFlg = true;

            _this.pt110ReqModel = Object.assign({}, _this.pt110ReqModel, _this.ptInitData.reqModel);
            _this.showFlg = true;
        }else{
            _this.doInit();
        }

        //close pupup
        EventBus.$on('closed', function() {
            _this.isModalShow = false;
            _this.colorSizeFlg = false;
        });
    },
    /*
    * Methods
    */
    methods: {
        doInit() {
            var _this = this;
            if ((!_this.pt110ReqModel.ptPageNo) && (!_this.pt110ReqModel.ptPageSize)){
                if (_this.pt110Init.reqModel){
                    if (_this.pt110Init.reqModel.ptPageNo){
                        _this.pt110ReqModel.ptPageNo = _this.pt110Init.reqModel.ptPageNo;
                    }else{
                        _this.pt110ReqModel.ptPageNo =  _this.pt110ReqModel.pageNo;
                    }

                    if (_this.pt110Init.reqModel.ptPageSize){
                        _this.pt110ReqModel.ptPageSize = _this.pt110Init.reqModel.ptPageSize;
                    }else{
                        _this.pt110ReqModel.ptPageSize = _this.pt110ReqModel.pageSize;
                    }
                }
            }
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT110 + _this.$UrlConstants.DO_INIT, _this.pt110ReqModel).then(function(response) {
                _this.pt110Init = response.data;

                if(_this.pt110Init.accessDialogFlg == 1 && !_this.pt110ReqModel.secretPassword) {
                    //_this.pt110ReqModel.secretPassword = '';
                    // シークレットパスワードが違います。
                    _this.warningMsg = _this.$i18n.t('pt110.labels.passwordError');
                    _this.showPassModal = true;
                    return;
                }

                // カートに入れるボタン表示オプション 0:表示しない 1:表示する
                if (_this.pt110Init.cartButtonFlg == 1) {
                    _this.cartShowFlg = true;
                }
                // お気に入りボタン表示オプション 0:表示しない 1:表示する
                if (_this.pt110Init.favouriteButtonFlg == 1) {
                    _this.favourireShowFlg = true;
                }
                if(response.data.productList != null){
                    _this.pageFeedData.totalRecord = response.data.totalRecord;
                    _this.pageFeedData.fromRecord = response.data.fromRecord;
                    _this.pageFeedData.toRecord = response.data.toRecord;
                    _this.pageFeedData.pageSize = response.data.pageSize;
                    _this.pageFeedData.pageNo = response.data.pageNo;
                    if(response.data.productList.length > 0){
                        _this.isPagingDisplay = true;
                    }else{
                        _this.isPagingDisplay = false;
                    }
                    // お気に入りボタンの初期値設定
                    for (var i = 0; i < _this.pt110Init.productList.length; i++) {
                        if (_this.pt110Init.productList[i].OKINI_ITEM_CD == "0") {
                            _this.favouriteAddFlg[i] = true;
                        } else {
                            _this.favouriteAddFlg[i] = false;
                        }
                    }
                }
                if (_this.pt110Init.productSortKbnList != null && _this.pt110Init.productSortKbnList.length > 0) {
                    _this.pt110Init.isDisplaySortFlg = true;
                } else {
                    _this.pt110Init.isDisplaySortFlg = false;
                }
                _this.dispPageSizeList = _this.pt110Init.pageSizeList;

                _this.pt110ReqModel = Object.assign({}, _this.pt110ReqModel, response.data.reqModel);
                _this.showFlg = true;
            }).catch(function(error) {
                common.errorAPI(error);
            });

        },

        okAction(evt) {
            this.warningMsg = '';
            if(this.pt110ReqModel.secretPassword) {
                this.setCookie('secret', this.pt110ReqModel.secretPassword, 1);
                this.doInit();
            } else {
                this.setCookie('secret', '', 0);
                evt.preventDefault();
                this.warningMsg = this.$i18n.t('pt110.labels.passwordInput');
            }
        },
        evtChangeCategory: function() {
            this.pt110ReqModel.categoryCd = this.categoryCd;
            this.reSearch();
        },
        evtChangeSearch: function() {
            this.pt110ReqModel.itemNm = this.searchNm;
            this.reSearch();
        },
        /*
        * 商品詳細画面へ遷移
        */
        doDetail: function(sItemNo){
            var _this = this;
            var categoryCd = _this.pt110ReqModel.categoryCd;
            var ptPageNo = _this.pt110ReqModel.pageNo;
            var ptPageSize = _this.pt110ReqModel.pageSize;
            var searchItemNm = _this.pt110ReqModel.itemNm;
            var itemNmOnly = _this.pt110ReqModel.itemNmOnly;
            var priceS = _this.pt110ReqModel.priceS;
            var priceE = _this.pt110ReqModel.priceE;
            var pointFlg = _this.pt110ReqModel.pointFlg;
            var allergyMaterialKbn = _this.pt110ReqModel.allergyMaterialKbn;
            _this.setCookie('secret', _this.pt110ReqModel.secretPassword, 1);

            _this.$emit("event-loading", true);
            _this.$router.push({ name: SiteConstants.PG030, params :{pageNo: 3, sItemNo: sItemNo, categoryCd: categoryCd
                                ,ptPageNo: ptPageNo,ptPageSize: ptPageSize, searchItemNm: searchItemNm
                                ,itemNmOnly: itemNmOnly,priceS: priceS, priceE: priceE,pointFlg: pointFlg, allergyMaterialKbn: allergyMaterialKbn}});
        },
        goDetail: function(sItemNo){
            // buttonタグ/inputタグ/まとめ買い詳細/関連商品 以外の場合は商品詳細画面へ遷移
            if (window.event.target.tagName != 'BUTTON' && window.event.target.tagName != 'INPUT'
                 && window.event.target.id != 'toMatome' && !/kanrenOrder_/.test(window.event.target.id)) {
                this.doDetail(sItemNo);
            }else{
                return false;
            }
            return true;
        },
        /**
        * cookie情報を取得
        * @param {String} cname, cookie name
        **/
        getCookie: function(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for(var i = 0; i <ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
        /**
        * cookieに情報をセット
        * @param {String} cname, cookie name
        * @param {String} cvalue, cookie value
        * @param {String} exHours, cookie expires
        **/
        setCookie: function(cname, cvalue, exHours) {
            var d = new Date();
            d.setTime(d.getTime() + (exHours * 60 * 60 * 1000));
            var expires = "expires="+ d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires;
        },
        /*
        * 注文処理
        */
        doOrder : function (ItemData) {
            var _this = this;
            // 数量が入力されていない場合はエラー
            if(ItemData.qty == '' || ItemData.qty == null){
                _this.msgConfirm = _this.$i18n.t('pt110.labels.messenge')
                _this.isModalShow = true;
                return;
            }
            ItemData.pointFlg = _this.pt110ReqModel.pointFlg;

            _this.$emit("event-loading", true);
            // カート追加処理
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT110 + _this.$UrlConstants.DO_ORDER, ItemData).then(function(response) {
                if(response.data.status == 'OK'){
                    _this.msgConfirm = ItemData.webItemName + _this.$i18n.t("pt110.labels.Order");
                    toastr.success(_this.msgConfirm);
                    _this.$emit('evt-change-quantily');
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                // eslint-disable-next-line
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, 'pt110');
                            if(resultValid){
                                if (resultValid.mapMsg[0].key == "count") {
                                    _this.msgConfirm = resultValid.mapMsg[0].mess;
                                } else {
                                    _this.msgConfirm = ItemData.webItemName +"は"+ resultValid.mapMsg[0].mess;
                                }
                                
                                _this.isModalShow = true;
                            }
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        /*
        * カート追加処理横レイアウト用
        */
        pt110doOrder: function(product){
            var _this = this;

            common.clearMessageEcSite(_this.listIdErr, 'pt110');

            var prdReq = {};
            prdReq.ordSItemNo = product.S_ITEM_CD;
            //prdReq.tnk = product.SALE_TNK;
            prdReq.tnk = product.PRICE;
            if (product.NEBIKI_PRICE > 0){
                prdReq.tnk = product.NEBIKI_PRICE;
            }
            prdReq.qty = product.QTY;
            prdReq.webItemName = product.WEB_ITEM_NM;
            
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT110 + _this.$UrlConstants.DO_AJAX, prdReq).then(function(response) {
                var colorSizeList = response.data.colSizList;
                // カラーサイズリストが存在する場合に表示
                if (common.getLengthObj(colorSizeList) > 0 && colorSizeList[0].VALUE != undefined) {
                    _this.colorSizeModal.colSizList = colorSizeList;
                    _this.colorSizeModal.csitemimg = product.IMG_URL1;
                    _this.colorSizeModal.colorTitle = _this.pt110Init.colorTitle;
                    _this.colorSizeModal.sizeTitle = _this.pt110Init.sizeTitle;
                    _this.dataColorSize = _this.colorSizeModal;
                    _this.colorSizeQty = product.QTY;
                    //_this.colorSizeTnk = product.SALE_TNK;
                    _this.colorSizeTnk = product.PRICE;
                    if (product.NEBIKI_PRICE > 0){
                        _this.colorSizeTnk = product.NEBIKI_PRICE;
                    }
                    _this.colorSizeItemNm = product.WEB_ITEM_NM;
                    
                    // カラーサイズ表示フラグON
                    _this.colorSizeFlg = true;
                    return;
                } else {
                    _this.doOrder(prdReq);
                }
            }).catch(function(error) {
                if(error != null && error != undefined){
                    common.errorAPI(error);
                }
            });
        },
        /*
        * カート追加処理縦レイアウト用
        */
        doOrderPt110 : function (ItemData) {
            var _this = this;
            common.clearMessageEcSite(_this.listIdErr, 'pt110');
            var itemCnt = 0;
            var sitemNos = [];
            var qtys = [];
            var animalQtys = [];
            var syukkaNums = [];
            // 数量が入力されていない場合はエラー
            for (var i = 0; i < ItemData.length; i++) {
                if (_this.pt110Init.auraOpt == 1){
                    if (ItemData[i].QTY >= 1 || ItemData[i].ANIMAL_QTY >= 1){
                        qtys[i] = ItemData[i].QTY;
                        animalQtys[i] = ItemData[i].ANIMAL_QTY;
                        sitemNos[i] = ItemData[i].S_ITEM_CD;
                        syukkaNums[i] = ItemData[i].SYUKKA_NUM;
                        if (ItemData[i].QTY >= 1){
                            itemCnt = itemCnt + 1;
                        } 
                    }
                } else {
                    if (ItemData[i].QTY >= 1) {
                        qtys[i] = ItemData[i].QTY;
                        animalQtys[i] = ItemData[i].ANIMAL_QTY;
                        sitemNos[i] = ItemData[i].S_ITEM_CD;
                        syukkaNums[i] = ItemData[i].SYUKKA_NUM;
                        itemCnt = itemCnt + 1;
                    }
                }
            }
            if(itemCnt == 0){
                _this.msgConfirm = _this.$i18n.t('pt110.labels.messenge')
                _this.isModalShow = true;
                return;
            }

            var reqModel = {};
            reqModel.sitemNos = sitemNos;
            reqModel.qtys = qtys;
            reqModel.animalQtys = animalQtys;
            reqModel.syukkaNums = syukkaNums;

            _this.$emit("event-loading", true);
            // カート追加処理
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT110 + _this.$UrlConstants.DO_INSERT, reqModel).then(function(response) {
                if(response.data.status == 'OK'){
                    _this.msgConfirm = _this.$i18n.t("pt110.labels.Order2");
                    toastr.success(_this.msgConfirm);
                    _this.$emit('evt-change-quantily');
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                // eslint-disable-next-line
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, 'pt110');
                            if(resultValid){
                                if (resultValid.mapMsg[0].key == "count") {
                                    _this.msgConfirm = resultValid.mapMsg[0].mess;
                                } else {
                                    var key = resultValid.mapMsg[0].key;
                                    var count = key.split('_')[1];
                                    _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                    _this.msgConfirm = ItemData[count].WEB_ITEM_NM +" は"+ resultValid.mapMsg[0].mess;
                                }
                                
                                _this.isModalShow = true;
                            }
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        /*
        * まとめ買い割引詳細画面へ
        */
        showMatomeDetail: function(product){
            var _this = this;
            var matomeCd = product.MATOME_CD;
            _this.$emit("event-loading", true);
            var ptPageNo = _this.pt110ReqModel.pageNo;
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 27, matomeCd: matomeCd, backPageNo: ptPageNo}});
        },
        /*
        * カラーサイズ商品コードセット
        */
        setValue(data){
            var _this = this;
            var prdReq = {};
            prdReq.ordSItemNo = data.sItemNo;
            prdReq.qty = _this.colorSizeQty;
            prdReq.tnk = _this.colorSizeTnk;
            prdReq.webItemName = _this.colorSizeItemNm;
            _this.doOrder(prdReq);
        },
        /*
        * お気に入り登録・解除処理
        * processKbn 1:登録 2:解除
        */
        pt110favorites: function(processKbn,sItemCd,webItemNm,index) {
            var _this = this;
            // 登録処理
            if (processKbn == 1) {
                _this.$emit("event-loading", true);
                //doFavourite
                axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT120 + _this.$UrlConstants.DO_FAVORITE, {sItemNo : sItemCd}).then(function(response) {
                    if(response.data.status == 'OK'){
                        // 登録完了
                        _this.msgConfirm = webItemNm + _this.$i18n.t("pt110.labels.favouriteAdd");
                        toastr.success(_this.msgConfirm);
                        _this.favouriteAddFlg[index] = false;
                        _this.reSearch();
                    } else {
                        // 登録失敗
                        _this.msgConfirm = webItemNm + _this.$i18n.t("pt110.labels.favouriteError");
                        _this.isModalShow = true;
                    }
                    _this.$emit("event-loading", false);
                }).catch(function(error) {
                    _this.$emit("event-loading", false);
                    common.errorAPI(error);
                });
            // 解除処理
            } else if (processKbn == 2) {
                axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT440 + _this.$UrlConstants.DO_DELETE, {sItemNo : sItemCd}).then(function() {
                    _this.msgConfirm = webItemNm + _this.$i18n.t("pt110.labels.favouriteDel");
                    toastr.success(_this.msgConfirm);
                    _this.favouriteAddFlg[index] = true;
                    _this.$emit("event-loading", false);
                    _this.reSearch();
                }).catch(function(error) {
                    _this.$emit("event-loading", false);
                    common.errorAPI(error);
                });
            }
        },
        /**
         * exec load url default when load main image is error
         * @param {Any} event, event exec error
         */
        getErrImage(event) {
            //get image default
            event.target.src = common.getImgDefault();
        },
        //Methods for pageFeed
        changeSearch: function(sortNo, pageSize, pageNo) {
            this.pt110ReqModel.pageSize = pageSize;
            this.pt110ReqModel.pageNo = pageNo;
            this.pt110ReqModel.orderByType = sortNo;
            // this.reSearch();
            var queryString = this.getQueryString(pageSize, 'ptPageSize');
            var publicPath = process.env.VUE_APP_PUBLIC_PATH;
            if (publicPath.substring(publicPath.length-1, publicPath.length) == "/") {
                publicPath = publicPath.substring(0, publicPath.length - 1);
            }
            location.href = publicPath + this.$route.path + '?' + queryString;
        },
        changePageSize: function(pageSize) {
            this.pt110ReqModel.pageSize = pageSize;
            this.reSearch();
            //var queryString = this.getQueryString(pageSize, 'ptPageSize');
            //location.href = process.env.VUE_APP_PUBLIC_PATH + this.$route.path + '?' + queryString;
        },
        changePageNo: function(pageNo) {
            this.pt110ReqModel.pageNo = pageNo;
            var queryString = this.getQueryString(pageNo, 'ptPageNo');
            location.href = process.env.VUE_APP_PUBLIC_PATH + this.$route.path + '?' + queryString;
        },
        changeDispSortNo: function(sortNo) {
            this.pt110ReqModel.orderByType = sortNo;
            var queryString = this.getQueryString(sortNo, 'ptOrderByType');
            location.href = process.env.VUE_APP_PUBLIC_PATH + this.$route.path + '?' + queryString;
        },
        reSearch: function() {
            var _this = this;
            _this.$emit("event-loading", true);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT110 + _this.$UrlConstants.DO_INIT, _this.pt110ReqModel).then(function(response) {
                _this.pt110Init = response.data;
                _this.pageFeedData.totalRecord = response.data.totalRecord;
                _this.pageFeedData.fromRecord = response.data.fromRecord;
                _this.pageFeedData.toRecord = response.data.toRecord;
                _this.pageFeedData.pageSize = response.data.pageSize;
                _this.pageFeedData.pageNo = response.data.pageNo;
                common.scrollTop();
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
            });
        },
        /**
         * format number value to currency value
         * @param {number} value, number to format
         */
        formatPrice: function(value){
            return common.formatPrice(value);
        },
        getQueryString: function(val, type){
            var query = this.$route.query;

            query.ptPageNo = this.pt110ReqModel.pageNo;
            query.ptPageSize = this.pt110ReqModel.pageSize;
            query.ptOrderByType = this.pt110ReqModel.orderByType;
            query.secretPassword = this.pt110ReqModel.secretPassword;
            query[type] = val;

            var queryString = "";
            var index= 0;
            for(var propertyName in query) {
                if(index == 0){
                    queryString += propertyName + '=' + query[propertyName];
                } else if (query[propertyName] != null){
                    queryString += '&' + propertyName + '=' + query[propertyName];
                }
                index++;
            }
            return queryString;
        },
        /* 
        * Function nvl for string item 
        */
        stringNvl: function(item, def){
            if(item == null || item == undefined){
                return def;
            }
            return item;
        },
        /* 
        * 匹数から数量を算出する
        */
        getItemQty: async function(qty, index, syukkaNum){
            var _this = this;
            if(_this.pt110Init.auraOpt == 1){
                _this.pt110Init.productList[index].QTY = (await commonEc.getItemQty(qty, syukkaNum)) % 1 !== 0 ? _this.pt110Init.productList[index].QTY : await commonEc.getItemQty(qty, syukkaNum);
            }
        },
        /* 
        * 数量から匹数を算出する
        */
        getAnimalQty: async function(qty, index, syukkaNum){
            var _this = this;
            if(_this.pt110Init.auraOpt == 1){
                _this.pt110Init.productList[index].ANIMAL_QTY = await commonEc.getAnimalQty(qty, syukkaNum);
            }
        },
        /*
        * カート追加テキストを使用するカート追加区分かチェック
        */
       doChkCartAddTxt: function(product) {
            if (product.CART_ADD_KBN == '5' || product.CART_ADD_KBN == '6') {
                return true;
            }
            return false;
       },
        /**
         * 関連注文商品ボタン押下時
         */
        pt110doKanrenOrder: function(itemCd, buttonKbn){
            var _this = this;
            _this.$emit("event-loading", true);
            if(buttonKbn == 0){
                // カート追加
                var prdReq = {};
                prdReq.S_ITEM_CD = itemCd;
                prdReq.QTY = 1;
                prdReq.WEB_ITEM_NM = _this.$i18n.t("pt110.labels.productOrther");

                _this.pt110doOrder(prdReq);
            }else{
                // 商品詳細
                _this.doDetail(itemCd);
            }
            
        },
    },
    created(){
        this.queryData = this.$route.query;
        this.paramsData = this.$route.params;
        if(this.queryData != null){
            if(this.queryData.ptPageNo != null){
                this.pt110ReqModel.pageNo = this.queryData.ptPageNo;
            }
            if(this.queryData.ptPageSize != null){
                this.pt110ReqModel.pageSize = this.queryData.ptPageSize;
            }
            if(this.queryData.ptOrderByType != null){
                this.pt110ReqModel.orderByType = this.queryData.ptOrderByType;
                this.pt110ReqModel.isfirst = false;
            }
            if(this.paramsData.searchItemNm != null){
                this.pt110ReqModel.itemNm = this.paramsData.searchItemNm;
            }
            if(this.queryData.searchItemNm != null){
                this.pt110ReqModel.itemNm = this.queryData.searchItemNm;
            }
            if(this.paramsData.categoryCd != null){
                this.pt110ReqModel.categoryCd = this.paramsData.categoryCd;
            }
            if(this.queryData.categoryCd != null){
                this.pt110ReqModel.categoryCd = this.queryData.categoryCd;
            }
            if(this.queryData.itemNmOnly != null){
                this.pt110ReqModel.itemNmOnly = this.queryData.itemNmOnly;
            }
            if(this.queryData.priceS != null){
                this.pt110ReqModel.priceS = this.queryData.priceS;
            }
            if(this.queryData.priceE != null){
                this.pt110ReqModel.priceE = this.queryData.priceE;
            }
            if(this.queryData.pointFlg != null){
                this.pt110ReqModel.pointFlg = this.queryData.pointFlg;
            }
            if(this.queryData.allergyMaterialKbn != null){
                this.pt110ReqModel.allergyMaterialKbn = this.queryData.allergyMaterialKbn;
            }
            if(this.queryData.secretPassword != null){
                this.pt110ReqModel.secretPassword = this.queryData.secretPassword;
            } else {
                var secret = this.getCookie('secret');
                if (secret != null && secret != undefined && secret != '') {
                    this.pt110ReqModel.secretPassword = secret;
                } else {
                    this.pt110ReqModel.secretPassword = '';
                }
            }
        }
        
    },
    watch: {
        evtChangeCategoryFlg() {
            this.evtChangeCategory();
        },
        evtChangeSearchFlg() {
            this.evtChangeSearch();
        }
    },
    beforeDestroy() {
        EventBus.$off('closed');
        EventBus.$off('is-loading');
    }
}
</script>
